import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';

import { TealiumConstants } from '../constants/tealium.constants';
import { TealiumAnalyticsEvent } from '../models/tealium-analytics-event';
import { TealiumAnalyticsService } from '../services/tealium-analytics.service';
import { AnalyticEventEvaluatorUtil } from '../utils/analytic-event-evaluator.util';
import { GlobalAnalyticsMapperUtil } from '../utils/global-analytics-mapper.util';

@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: 'button:not([disable-tracking]), [custom-tracking]'
})
export class TealiumAnalyticsDirective implements OnInit {
	@Input() public eventId: string = 'event15';
	@Input('track-event') public trackEvent?: string;

	constructor(private element: ElementRef, private tealiumAnalyticsService: TealiumAnalyticsService) { }

	public ngOnInit(): void {
		if (!window['globalAnalyticsParams']) {
			window['globalAnalyticsParams'] = {};
		}
		GlobalAnalyticsMapperUtil.setToolName();
	}

	@HostListener('click')
	public onClick(): void {

		if (GlobalAnalyticsMapperUtil.getToolName() === TealiumConstants.TOOL_NAMES.SCENARIO_TESTER_TOOL) {
			const tealiumEvent = new TealiumAnalyticsEvent(TealiumConstants.TOOLS_EVENT.GENERIC, { linkName: this.trackEvent });
			this.tealiumAnalyticsService.trackEventTealium(tealiumEvent);

		} else {
			const elementText = this.element.nativeElement.innerText.trim().toLowerCase();
			const eventName = elementText === 'sign in' ? AnalyticEventEvaluatorUtil.transform('Session Expired : Sign in') : this.trackEvent || elementText;

			// only track the event if the event is valid
			if (eventName) {
				const tealiumEvent = new TealiumAnalyticsEvent(eventName, null);
				this.tealiumAnalyticsService.trackEventTealium(tealiumEvent);
			}
		}
	}
}
